export class WorkItemSubtotal {
	constructor(
		public totalAmount: number = 0,
		public paidAmount: number = 0,
		public leftAmount: number = 0,
		public globalDiscount: number = 0
	) {}
}
